export const transferSteps = {
  transferStepsBeneficiary: "Beneficiario",
  transferStepsAmount: "Monto",
  transferStepsTransfer: "Transferir",
  transferStepsError: "Transferencia fallida",
  transferStepsErrorDesc_1: "Su transferencia ha fallado, verifique sus datos o contacte a soporte.",
  transferStepsSuccess: "Transferencia exitosa",
  transferStepsSuccessMessage: "Su transferencia ha sido procesada con éxito.",
  transferStepsNext: "Siguiente",
  transferStepsConfirm: "Confirmar",
  transferStepsBack: "Volver",
  transferStepsCancel: "Cancelar",

  // Content step 1,
  transferStepsSelectContact: "Seleccione un contacto",
  transferStepsSelectContactOption: "Seleccione un contacto",
  transferSteps_loading: "Cargando contactos...",
  transferSteps_loadingError: "Error cargando contactos",

  // Content step 2,
  transferStepsTransferAmount: "Ingresa el monto a transferir",
  transferStepsTransferAmountInput: "Ingresa el monto",
  transferStepsAmountError: "Monto inválido",
  transferStepsAmountError2: "Balance insuficiente",

  // Content step 3,
  transferSteps_3_Confirm: "Confirmación de Transferencia",
  transferSteps_3_Beneficiary: "Beneficiario",
  transferSteps_3_Amount: "Monto",
};
